module.exports = __webpack_public_path__ + "static/media/Top-Shape.f549cd19.png";